import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#F69100",
  d: "M23.582 20.035c3.132-.33 7.852-1.83 7.852-1.83l.706 1.936 1.163-.122c.215-.023.43.019.622.119a2.183 2.183 0 0 1 .38 3.613 1.1 1.1 0 0 1-.584.246l-.665.07-.681 3.088s-4.72 1.501-7.852 1.83c-3.131.33-7.815-.184-7.815-.184L15.4 25.922l-.666.07a1.1 1.1 0 0 1-.621-.119 2.183 2.183 0 0 1-.38-3.613c.166-.138.369-.223.583-.246l1.163-.122.289-2.041s4.683.513 7.814.184ZM24 8c3.148 0 8-1 8-1l.5 2h1.17c.215 0 .426.064.605.183a2.183 2.183 0 0 1 0 3.634c-.18.12-.39.183-.606.183H33l-1 3s-4.85 1-8 1c-3.148 0-7.752-1-7.752-1l-1-3h-.67c-.215 0-.425-.064-.605-.183a2.183 2.183 0 0 1 0-3.634c.18-.12.39-.183.606-.183h1.17l.5-2S20.85 8 24 8ZM24 32c3.148 0 8-1 8-1l.5 2h1.17c.215 0 .426.064.605.183a2.183 2.183 0 0 1 0 3.634c-.18.12-.39.183-.606.183H33l-1 3s-4.85 1-8 1c-3.148 0-7.752-1-7.752-1l-1-3h-.67c-.215 0-.425-.064-.605-.183a2.183 2.183 0 0 1 0-3.634c.18-.12.39-.183.606-.183h1.17l.5-2S20.85 32 24 32ZM19.5 17v3m0 9v2.5m9-3.5v3.5m0-14.5v2M35.683 16.848a5.98 5.98 0 0 1 3.573 4.518M11.941 28.819a5.98 5.98 0 0 1-3.512-4.566"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }